// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"7c2ba738","453":"393c2912","689":"6c0dbbe2"}[chunkId] + ".chunk.js";
};